import InWallIcon from "../../assets/product-list-assets/wifi-InWall.svg";
import type { ProductListGroup } from "../../types";

export const wifiWall: ProductListGroup = {
  id: "wifiWall",
  title: "productListGroup.wifiWall.title",
  seriesLabel: "modelCompare.seriesLabel.wifiWall",
  icon: {
    src: InWallIcon,
    width: 16,
    height: 21,
  },
};
